module.exports = __webpack_public_path__ + "img/step_01.0a358df1.svg";